import { ResultRecord, ServiceResponse } from "@rsm-hcd/javascript-core";

// TODO: Move to open source.
// See https://github.com/AndcultureCode/AndcultureCode.JavaScript.React/issues/55 for more information.

// ---------------------------------------------------------------------------------------------
// #region Functions
// ---------------------------------------------------------------------------------------------

const ServiceResponseFactory = {
    /**
     * Default successful list response
     */
    successfulList<T>(
        resultObjects?: Array<T>,
        rowCount?: number
    ): ServiceResponse<T> {
        return {
            resultObjects: resultObjects ?? [],
            rowCount: rowCount ?? 0,
            status: 200,
        };
    },

    /**
     * Default successful get response
     */
    successfulGet<T>(resultObject?: T): ServiceResponse<T> {
        return {
            result: new ResultRecord<T>({ resultObject }),
            resultObject,
            resultObjects: [],
            rowCount: 0,
            status: 200,
        };
    },

    /**
     * Default successful create response
     */
    successfulCreate<T>(resultObject?: T): ServiceResponse<T> {
        return {
            result: new ResultRecord<T>({ resultObject }),
            resultObject,
            resultObjects: [],
            rowCount: 0,
            status: 200,
        };
    },

    /**
     * Default successful delete response
     */
    successfulDelete<T>(resultObject?: T): ServiceResponse<T> {
        return {
            result: new ResultRecord<T>({ resultObject }),
            resultObject,
            resultObjects: [],
            rowCount: 0,
            status: 200,
        };
    },

    /**
     * Default successful update response
     */
    successfulUpdate<T>(resultObject?: T): ServiceResponse<T> {
        return {
            result: new ResultRecord<T>({ resultObject }),
            resultObject,
            resultObjects: [],
            rowCount: 0,
            status: 200,
        };
    },

    /**
     * Default failed get response
     */
    failedGet<T>({
        resultObject,
        errorMessage,
    }: { resultObject?: T; errorMessage?: string } = {}): ServiceResponse<T> {
        return {
            result: new ResultRecord<T>({ ...resultObject }).addError(
                "ERROR",
                errorMessage ?? "Failed to get"
            ),
            resultObject,
            resultObjects: [],
            rowCount: 0,
            status: 400,
        };
    },

    /**
     * Default failed create response
     */
    failedCreate<T>(resultObject?: T): ServiceResponse<T> {
        return {
            result: new ResultRecord<T>({ ...resultObject }).addError(
                "ERROR",
                "Failed to create"
            ),
            resultObject,
            resultObjects: [],
            rowCount: 0,
            status: 400,
        };
    },

    /**
     * Default failed delete response
     */
    failedDelete<T>(resultObject?: T): ServiceResponse<T> {
        return {
            result: new ResultRecord<T>({ ...resultObject }).addError(
                "ERROR",
                "Failed to delete"
            ),
            resultObject,
            resultObjects: [],
            rowCount: 0,
            status: 400,
        };
    },
    /**
     * Default failed update response
     */
    failedUpdate<T>(resultObject?: T): ServiceResponse<T> {
        return {
            result: new ResultRecord<T>({ ...resultObject }).addError(
                "ERROR",
                "Failed to update"
            ),
            resultObject,
            resultObjects: [],
            rowCount: 0,
            status: 400,
        };
    },
};

// #endregion Functions

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default ServiceResponseFactory;

// #endregion Exports
